const initialCamera = {
    cameraLists: [],
    cameraStatus: [],
    cameraPermissions: {},
    changedCameraStatus: [],
    loadingCamera: false,
    errorsCamera: {}
}

const cameraReducer = (state = initialCamera, action) => {
    switch (action.type) {
        case "GET_CAMERALIST_PENDING":
        case "ADD_CAMERA_PENDING":
        case "UPDATE_CAMERA_PENDING":
        case "UPDATE_CAMERA_STATUS_PENDING":
        case "DELETE_CAMERA_PENDING":
        case "PLAY_CAMERA_PENDING":
        case "STOP_CAMERA_PENDING":
        case "GET_CAMERALISTBYID_PENDING":
            return { ...state, loadingCamera: true };

        case "GET_CAMERALIST_FULFILLED":
            return {
                ...state,
                loadingCamera: false,
                cameraLists: action.payload,
                cameraCount: action.cameraCount,
                cameraPermissions: action.permissions,
            };

        case "ADD_CAMERA_FULFILLED":
            return {
                ...state,
                loadingCamera: false,
                changedCameraStatus: action.payload,
            };

        case "UPDATE_CAMERA_FULFILLED":
            return {
                ...state,
                loadingCamera: false,
                changedCameraStatus: action.payload,
            };

        case "UPDATE_CAMERA_STATUS_FULFILLED":
            return {
                ...state,
                loadingCamera: false,
                changedCameraStatus: action.payload,
            };

        case "STOP_CAMERA_FULFILLED":
            return {
                ...state,
                loadingCamera: false,
                changedCameraStatus: action.payload,
            };

        case "GET_CAMERALISTBYID_FULFILLED":
            return {
                ...state,
                loadingCamera: false,
                cameraLists: action.payload
            };

        case "DELETE_CAMERA_FULFILLED":
            return {
                ...state,
                loadingCamera: false,
                changedCameraStatus: action.payload
            };

        case "RESET_DELETE_CAMERA_STATUS":
            return {
                ...state,
                loadingCamera: false,
                changedCameraStatus: [],
                errorsCamera: {}
            };

        case "GET_CAMERALIST_REJECTED":
        case "ADD_CAMERA_REJECTED":
        case "UPDATE_CAMERA_REJECTED":
        case "UPDATE_CAMERA_STATUS_REJECTED":
        case "DELETE_CAMERA_REJECTED":
        case "PLAY_CAMERA_REJECTED":
        case "STOP_CAMERA_REJECTED":
        case "GET_CAMERALISTBYID_REJECTED":
            return {
                ...state,
                loadingCamera: false,
                errorsCamera: action.payload
            };

        default:
            return state;
    }
}

export default cameraReducer;
